$(function () {
	const printLink = document.querySelector(".hero a.hero__print");

	if (!printLink) return;

	printLink.addEventListener("click", function (e) {
		e.preventDefault();
		window.print();
	});
	
});
